import currentUserApi, { type CurrentUserDetails } from './currentUserApi';

export { type CurrentUserDetails };

export const { useGetCurrentUserQuery } = currentUserApi;

export default currentUserApi;
